export const policyMap = {
  oop: {
    display: 'OutOfPolicy',
    color: '#ff8700',
  },
  high: {
    display: 'HighPolicy',
    color: '#ba1d1a',
  },
};
